<template>
  <div class="prediction" id="prediction" ref="prediction"></div>
</template>

<script>
export default {
  name: "prediction",
  data() {
    return {};
  },
  mounted() {
    this.prediction();
  },
  methods: {
    prediction() {
      let myEchart = this.$echarts.init(document.getElementById("prediction"));
        // var echarts = require("echarts");

      let label = [
        "现在",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
      ];
      let value = ["23", "20", "20", "19", "18", "17", "16"];
      let option = {
   
    grid: {
        top:'20%',
        left:'1%',
        bottom:'2%',
        right:'5%',
        containLabel: true,
    },
    
    xAxis: [
        {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
                formatter: '{value}',
                fontSize: 10,
                margin: 5,
                textStyle: {
                    color: '#6e6e6e',
                },
            },
            axisLine: {
                lineStyle: {
                    color: '#3c3c3a',
                },
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: '#243753',
                },
            },
            axisTick: {
                show: true,
                inside:true,
                lineStyle:{
                    color:'#878787'
                }
            },
            data: label,
        },
    ],
    yAxis: 
        {
            name:'24小时预报',
            nameLocation:'end',
            nameGap:-5,
            
            boundaryGap: false,
            type: 'value',
            axisLabel: {
                textStyle: {
                    color: '#6e6e6e',
                },
            },
            splitNumber :1,
            nameTextStyle: {
                color: '#fff',
                fontSize: 12,
                
                padding:[10,0,12,20]
            },
            splitLine: {
                show:false,
                lineStyle: {
                    color: '#243753',
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                     color: '#3c3c3a',
                },
            },
            axisTick: {
                show: false,
            },
        },
      
    series: [
        {
            name: '报名',
            type: 'line',
            smooth: true,
            showSymbol: true,
            symbolSize: 5,
            zlevel: 3,
            itemStyle: {
                color: 'white',
                borderColor: 'white',
            },
            lineStyle: {
                normal: {
                    width: 2,
                    color: '#fba500',
                },
            },
            areaStyle: {
                normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                            {
                                offset: 0,
                                color: 'rgba(251,165,0,0.5)',
                            },
                            {
                                offset: 0.8,
                                color: 'rgba(251,165,0,0)',
                            },
                        ],
                        false
                    ),
                },
            },
            data: value,
        },
    ],
};

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.prediction {
  width: 100%;
  height: 100%;
}
</style>